import { usePageTogglers } from "@Client/@Composables/application-standalone/page-helpers/usePageToggler";
import { computed, defineComponent, onBeforeUnmount, watch } from "@vue/composition-api";
import PageTogglerLayout from "../layout/page-toggler-layout.vue";
import { useScrollTopOnLoad } from "@Shared/@Composables/generic/useScrollTopOnLoad";
import PageStepLayout from "@Client/@Modules/application-standalone/components/layout/page-step-layout.vue";
import OtherPropertyInformation from "@Client/@Modules/application-standalone/components/pages/other-properties/other-property-information.vue";
import OtherPropertySummary from "@Client/@Modules/application-standalone/components/pages/other-properties/other-property-summary.vue";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_FLOW } from "@Shared/@Types/application/application-enums";
export default defineComponent({
  name: "OtherPropertiesPage",
  components: {
    PageTogglerLayout,
    OtherPropertyInformation,
    OtherPropertySummary,
    PageStepLayout
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    useScrollTopOnLoad();
    const {
      bindApplication
    } = useBindApplication();
    const flowSelection = bindApplication("[flow]");
    const isRefinanceOrSwitchTransfer = computed(() => flowSelection.value === APPLICATION_FLOW.REFINANCE || flowSelection.value === APPLICATION_FLOW.SWITCH_TRANSFER);
    const {
      handlePageTogglerNavigation,
      showInformationPage,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack,
      navigateToInformationPage
    } = usePageTogglers();
    watch(showInformationPage, newValue => {
      emit("update:showInformationPage", newValue);
      emit("show-errors", 0);
    }, {
      immediate: true
    });
    onBeforeUnmount(() => {
      emit("show-errors", 0);
    });
    return {
      showInformationPage,
      handlePageTogglerNavigation,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack,
      navigateToInformationPage,
      isRefinanceOrSwitchTransfer
    };
  }
});